import { css } from 'styled-components';
import { ACTION_CELL_WIDTH, ACTION_CELL_WIDTH_COMPACT, CELL_PADDING_COMPACT, CELL_PADDING_DEFAULT, CHECKBOX_CELL_WIDTH, DATA_ATTR_CAN_SCROLL_LEFT_PAST_STICKY, DATA_ATTR_CAN_SCROLL_RIGHT, DND_CELL_WIDTH, Z_INDEX_ACTION_CELL, Z_INDEX_CHECKBOX_CELL, } from './constants';
export const specialCellCenter = css `
  justify-content: center;
`;
export const dndCellStyles = ($compact) => css `
  width: ${DND_CELL_WIDTH};
  padding: ${$compact ? CELL_PADDING_COMPACT : CELL_PADDING_DEFAULT};
  border-right: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
export const checkboxCellStyles = ($compact) => css `
  width: ${CHECKBOX_CELL_WIDTH};
  padding: ${$compact ? CELL_PADDING_COMPACT : CELL_PADDING_DEFAULT};
  position: sticky;
  left: 0;
  z-index: ${Z_INDEX_CHECKBOX_CELL};
  border-right: 1px solid ${({ theme }) => theme.colors.grey10_1};
  background: inherit;

  [${DATA_ATTR_CAN_SCROLL_LEFT_PAST_STICKY}='true'] & {
    ${({ theme }) => theme.shadows.medium}
  }
`;
export const actionCellStyles = ($compact) => css `
  width: ${$compact ? ACTION_CELL_WIDTH_COMPACT : ACTION_CELL_WIDTH};
  padding: ${$compact ? CELL_PADDING_COMPACT : CELL_PADDING_DEFAULT};
  // The action lives in a trailing auto track that stretches to absorb leftover space; this pins the
  // fixed-width action cell to the right edge of that track (so the action stays flush right even when
  // no data column fills the row). When columns overflow, the track shrinks to content and sticky takes over.
  margin-left: auto;
  position: sticky;
  right: 0;
  z-index: ${Z_INDEX_ACTION_CELL};
  border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
  background: inherit;

  [${DATA_ATTR_CAN_SCROLL_RIGHT}='true'] & {
    ${({ theme }) => theme.shadows.medium}
  }
`;
